import { z } from "zod/v4";
import { nuqsCommaArray } from "#/modules/util.pagination/search.nuqs";

// Search params schema for sportdeelname statistieken: class filter.

/** URL state for the school Sportdeelnames statistieken page. Empty `klasIds` means all classes. */
export const sportParticipationSearchSchema = z.object({
  klasIds: nuqsCommaArray,
});

export type SportdeelnameStatistiekenFilters = z.infer<typeof sportParticipationSearchSchema>;

/** Defaults stripped from the URL by `stripSearchParams`. */
export const SPORT_PARTICIPATION_SEARCH_DEFAULTS: Pick<
  SportdeelnameStatistiekenFilters,
  "klasIds"
> = {
  klasIds: [],
};
